import React from 'react';
import { LinkedThirdPartyName } from './LinkedThirdparties.styles';

type LinkedThirdPartyHiddenRowProps = {
  onClickThirdPartyName: () => void;
};

const LinkedThirdPartyHiddenRow: React.FC<LinkedThirdPartyHiddenRowProps> = ({
  onClickThirdPartyName,
}) => {
  return (
    <>
      <td>
        <LinkedThirdPartyName onClick={onClickThirdPartyName}>***********</LinkedThirdPartyName>
      </td>
      <td>***********</td>
      <td>***********</td>
      <td>******</td>
      <td>******</td>
      <td>**/**/****</td>
      <td>******</td>
      <td>***********</td>
      <td></td>
    </>
  );
};

export default LinkedThirdPartyHiddenRow;
